module.exports = __webpack_public_path__ + "img/Step5.5c504a15.png";